import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { DashboardActivitiesResponseSchema } from "../schemas/dashboardV2Schemas";

const API_VERSION = 'v4';

const useDashboardActivities = (property_id?: string, type?: 'today_check_in' | 'in_house' | 'today_check_out') => {
    return useQuery({
        queryKey: ['dashboard-activities', property_id, type],
        queryFn: async () => {
            const response = await privateApi.get(`/${API_VERSION}/dashboard/activities`, {
                params: { property_id, type }
            });
            const validationResult = DashboardActivitiesResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Dashboard Activities data format");
            }
            return validationResult.data;
        },
        enabled: !!property_id && !!type,
        retry: import.meta.env.VITE_MAX_RETRY ? parseInt(import.meta.env.VITE_MAX_RETRY as string) : 1,
        refetchOnWindowFocus: false
    });
};

export default useDashboardActivities;
